import React, { PureComponent, PropTypes } from 'react';

export function longRecruitName(recruit, withYear = false) {
  if (!recruit) {
    return null;
  }

  const { firstName, lastName } = recruit;
  let output = '';

  if (firstName && lastName) {
    output = `${firstName} ${lastName}`;
  } else if (firstName) {
    output = firstName;
  } else if (lastName) {
    output = lastName;
  }

  if (withYear && recruit.year) {
    output += ` (${`${recruit.year}`})`;
  }

  return output;
}

export default class LongRecruitName extends PureComponent {
  static propTypes = {
    bold: PropTypes.bool,
    recruit: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string
    }),
    withYear: PropTypes.bool
  };

  static defaultProps = {
    bold: false,
    withYear: false
  };

  render() {
    const { bold, className, recruit, withYear, style } = this.props;
    const name = longRecruitName(recruit, withYear);

    if (bold) {
      return <strong className={className}>{name}</strong>;
    } else {
      return <span style={style} className={className}>{name}</span>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/LongRecruitName.jsx